"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var date_1 = require("@utils/date/date");
var react_i18next_1 = require("react-i18next");
var ExtendableText_1 = __importDefault(require("@components/ExtendableText"));
var ConfirmDelete_1 = __importDefault(require("@components/Modal/ConfirmDelete"));
var moderationNoteSlice_1 = require("@features/ItemCommon/state/moderationNoteSlice");
var _store_1 = require("@store");
var NoteFilters_1 = require("@features/ItemCommon/components/ModerationNote/NoteFilters");
var moderationNotes_1 = require("@features/ItemCommon/service/moderationNotes");
var DEFAULT_LINE_NUMBER = 6;
function Note(props) {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, _store_1.useAppDispatch)();
    var _b = __read(react_1.default.useState(false), 2), deleteModalIsOpen = _b[0], setDeleteModalIsOpen = _b[1];
    var domain = props.domain, angularJsDependencies = props.angularJsDependencies, note = props.note, job = props.job, updateModerationNotes = props.updateModerationNotes;
    var team = angularJsDependencies.CurrentUser.roles.find(function (r) { return r.domain === domain; });
    var isAdmin = team && team.role === 'Admin';
    var searchRemoteIdText = "".concat(note.remoteId);
    var timestampText = (0, date_1.formatDate)(new Date(note.createdAt));
    var timestampFromNow = (0, date_1.getIntervalLabel)(new Date(note.createdAt));
    var noteContentSubText = note.content;
    if (note.content && note.content.length > 0) {
        noteContentSubText = (_a = note.content) === null || _a === void 0 ? void 0 : _a.substring(0, 18);
        noteContentSubText += '...';
    }
    var currentUserEmail = angularJsDependencies.CurrentUser.email;
    var createdByCurrentUser = note.creatorEmail === currentUserEmail;
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)({ 'moderation-note': true, 'created-by-current-user': createdByCurrentUser }), "data-cy": "moderation-note-element" },
        react_1.default.createElement("div", { className: "moderation-note__fields" },
            react_1.default.createElement("a", { className: "moderation-note__fields__remote-id", target: "_blank", rel: "noopener noreferrer", href: angularJsDependencies.href('app.assignment.search', {
                    domain: domain,
                    filters: encodeURIComponent("document.id:".concat(searchRemoteIdText)),
                }) },
                "#",
                note.remoteId),
            react_1.default.createElement(NoteFilters_1.FieldFilters, { note: note })),
        react_1.default.createElement("div", { className: "moderation-note__text" },
            react_1.default.createElement(ExtendableText_1.default, { contentBody: note.content, numberOfLinesToShow: DEFAULT_LINE_NUMBER })),
        (note.creatorEmail || note.createdAt) && (react_1.default.createElement("div", { className: "moderation-note__info", title: t('ITEM.MODERATION_NOTES.NOTE_CREATED_BY_TOOLTIP_REACT', {
                USER_EMAIL: note.creatorEmail,
                TIMESTAMP: timestampText,
            }) },
            react_1.default.createElement("span", { className: "moderation-note__info__email" }, createdByCurrentUser ? t('ITEM.MODERATION_NOTES.CREATED_BY_CURRENT_USER') : note.creatorEmail),
            react_1.default.createElement("span", { className: "moderation-note__info__date" }, timestampFromNow))),
        (createdByCurrentUser || isAdmin) && (react_1.default.createElement("div", { className: "eva-moderation-note-actions-container" },
            react_1.default.createElement("div", { className: "eva-moderation-note-actions-wrapper" },
                react_1.default.createElement("div", { className: "moderation-note-actions" },
                    react_1.default.createElement("div", { className: "moderation-note-action eva-tooltip-container implioicons-trash", onClick: function () { return setDeleteModalIsOpen(true); } },
                        react_1.default.createElement("span", { className: "eva-tooltip" }, t('ITEM.MODERATION_NOTES.DELETE_THIS_NOTE'))))))),
        react_1.default.createElement(ConfirmDelete_1.default, { onDelete: function () {
                return dispatch((0, moderationNoteSlice_1.deleteNote)({ domain: domain, noteId: note.id, noteContentSubText: noteContentSubText })).then(function () {
                    job.ad &&
                        (0, moderationNotes_1.fetchModerationNotes)(domain, job.ad).then(function (notes) {
                            if (notes) {
                                updateModerationNotes(notes);
                            }
                        });
                });
            }, isOpen: deleteModalIsOpen, setIsOpen: setDeleteModalIsOpen, title: t('ITEM.MODERATION_NOTES.DELETE_POPOVER.TITLE'), text: t('ITEM.MODERATION_NOTES.DELETE_POPOVER.TEXT_REACT', { noteContentSubText: noteContentSubText }) })));
}
exports.default = Note;
